module.exports = __webpack_public_path__ + "img/figure-4.f82ee9b1.png";